export interface IGroup {
  id: number | null;
  groupName: string;
}

export class Group implements IGroup {
  constructor(public id: number | null, public groupName: string) {}
}
